import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { useDirect, useTheme } from "../hooks";
import { CustomToast, Theme } from "../component";
import router from "./router";
import { useEffect } from "react";
import keyNames from "../keyName";
import { useSelector } from "react-redux";

const Layout = () => {
  const themes = useTheme();
  const directDispatch = useDirect();
  const storeData = useSelector((state) => state.mainReducer);
  const { forceLogOut } = storeData;
  useEffect(() => {
    if (forceLogOut) {
      directDispatch(false, keyNames.forceLogOut);
      // If the user originally arrived via a public share link, return them
      // there so they can re-claim with a different account. Otherwise go
      // to the default login page. Consumed once.
      const returnTo = sessionStorage.getItem("returnToShare");
      if (returnTo) sessionStorage.removeItem("returnToShare");
      window.location.href = returnTo || "/";
    }
  }, [forceLogOut, directDispatch]);

  return (
    <ThemeProvider theme={themes}>
      <Theme />
      <CustomToast />
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </ThemeProvider>
  );
};
export default Layout;
